export default {
    cn: {
        openTrades: {
            tableHead: [
                { key: 'LOGIN', value: '账号' },
                { key: 'NAME', value: '客户姓名' },
                { key: 'CURRENCY', value: '入金货币' },
                { key: 'IB_ID', value: '代理账号' },
                { key: 'EQUITY', value: '客户净值' },
                { key: 'CLOSED_PL', value: '今日平仓盈亏' },
                { key: 'FLOATING_PL', value: '今日客户盈亏' },
                { key: 'PL', value: '浮动盈亏' },
                { key: 'MARGIN_LEVEL', value: '保证金水平' },
            ],
            expandHead: {
                SYMBOL: '产品',
                BUY_VOLUME: '手数(买)',
                SELL_VOLUME: '手数(卖)',
                VOLUME: '净手数',
                PL: '浮动盈亏',
            },
            filterOptions: {
                LOGIN: '账号',
                NAME: '客户姓名',
                IB_ID: '代理账号',
            },
            excelName: '未平仓交易统计',
            symbolText: '请选择交易产品或产品组',
            filterText: '通过关键字对现有数据进行搜索',
        }
    },
    hk: {
        openTrades: {
            tableHead: [
                { key: 'LOGIN', value: '賬號' },
                { key: 'NAME', value: '客戶姓名' },
                { key: 'CURRENCY', value: '入金貨幣' },
                { key: 'IB_ID', value: '代理賬號' },
                { key: 'EQUITY', value: '客戶净值' },
                { key: 'CLOSED_PL', value: '今日平倉盈虧' },
                { key: 'FLOATING_PL', value: '今日客戶盈虧' },
                { key: 'PL', value: '浮動盈虧' },
                { key: 'MARGIN_LEVEL', value: '保證金水平' },
            ],
            expandHead: {
                SYMBOL: '產品',
                BUY_VOLUME: '手數(買)',
                SELL_VOLUME: '手數(賣)',
                VOLUME: '净手數',
                PL: '浮動盈虧',
            },
            filterOptions: {
                LOGIN: '賬號',
                NAME: '客戶姓名',
                IB_ID: '代理賬號',
            },
            excelName: '未平倉交易統計',
            symbolText: '請選擇交易產品或產品組',
            filterText: '通過關鍵字對現有數據進行搜索',
        }
    },
    en: {
        openTrades: {
            tableHead: [
                { key: 'LOGIN', value: 'Login' },
                { key: 'NAME', value: 'Name' },
                { key: 'CURRENCY', value: 'Currency' },
                { key: 'IB_ID', value: 'IB Account' },
                { key: 'EQUITY', value: 'Equity' },
                { key: 'CLOSED_PL', value: 'Closed PL' },
                { key: 'FLOATING_PL', value: 'Client Floating PL' },
                { key: 'PL', value: 'Floating PL' },
                { key: 'MARGIN_LEVEL', value: 'Margin Level' },
            ],
            expandHead: {
                SYMBOL: 'Symbol',
                BUY_VOLUME: 'Volume(Buy)',
                SELL_VOLUME: 'Volume(Sell)',
                VOLUME: 'Volume',
                PL: 'Floating PL',
            },
            filterOptions: {
                LOGIN: 'Login',
                NAME: 'Name',
                IB_ID: 'IB Account',
            },
            excelName: 'Open Trades Statistics',
            symbolText: 'Please select symbols or securities',
            filterText: 'Search existing data by keyword',
        }
    }
}


// WEBPACK FOOTER //
// ./src/language/manager-report/openTradesReport.js